import { Controller } from "@hotwired/stimulus"

// Moves the .bd-payment-sidebar element into a mobile slot when the
// viewport drops below the breakpoint, and back to its original position
// when it grows again. This keeps a single recap (with promo + tip) in
// the DOM at any time — no duplicate ids, no duplicate Stimulus
// controllers — while still letting the desktop sidebar live in the right
// column and the mobile recap appear inline between Section 2 and 3.
const MOBILE_QUERY = "(max-width: 640px)"

export default class extends Controller {
  static values = { mobileAnchor: String }

  connect() {
    this._home = this.element.parentElement
    this._homeNext = this.element.nextSibling
    this._mql = window.matchMedia(MOBILE_QUERY)
    this._onChange = () => this.applyPlacement()
    if (this._mql.addEventListener) {
      this._mql.addEventListener("change", this._onChange)
    } else {
      this._mql.addListener(this._onChange)
    }
    this.applyPlacement()
  }

  disconnect() {
    if (this._mql && this._onChange) {
      if (this._mql.removeEventListener) {
        this._mql.removeEventListener("change", this._onChange)
      } else {
        this._mql.removeListener(this._onChange)
      }
    }
    this._mql = null
    this._onChange = null
  }

  applyPlacement() {
    const slot = document.getElementById(this.mobileAnchorValue)
    if (!slot) return
    if (this._mql.matches) {
      // Move into the mobile slot (idempotent — appendChild is a no-op
      // when the element is already the slot's only child).
      if (this.element.parentElement !== slot) {
        slot.appendChild(this.element)
      }
    } else if (this._home && this.element.parentElement !== this._home) {
      // Restore to original position. Use the saved next sibling so the
      // sidebar lands back in the same spot relative to its neighbors.
      if (this._homeNext && this._homeNext.parentElement === this._home) {
        this._home.insertBefore(this.element, this._homeNext)
      } else {
        this._home.appendChild(this.element)
      }
    }
  }
}
